import { createSlice , createAsyncThunk } from '@reduxjs/toolkit'
import ProviderManager from '../../../provider/providerManager';

export const getSurfingDataUsageDetails = createAsyncThunk('cellularSurfingUseDetailsBlock/getSurfingDataUsageDetails', async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('getSurfingDataUsageDetails', [data.isPrivate, data.blockId, data.isRefresh]);
      return result;
    } catch (error) {
      return { Body: { userMobileNumbers: [], error: true } };
    }
}); 

export const addPackage = createAsyncThunk('cellularSurfingUseDetailsBlock/addPackage', async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('surfingUseAddPackage', [data.subscriber, data.soc]);
      return result;
    } catch (error) {
      return { Body: { IsSuccess: false } };
    }
}); 

const cellularSurfingUseDetailsBlockSlice = createSlice({
    name: 'cellularSurfingUseDetailsBlock',
    initialState: {
        subscribers: null,
        fatalError: false,
        isSuccessAddPackage: false,
        showPopUpExpanding: false,
        showPopUpAddPackageResult: false,
        showPopUpLink: false,
        selectedSubscriber: null,
    },
    reducers: {
        openPopUpExpanding: (state, action) => {
        state.showPopUpExpanding = true;
        },
        closePopUpExpanding: (state, action) => {
          state.showPopUpExpanding = false;
        },
        openPopUpAddPackageResult: (state, action) => {
          state.showPopUpAddPackageResult = true;
        },
        closePopUpAddPackageResult: (state, action) => {
          state.showPopUpAddPackageResult = false;
        },
        openPopUpLink: (state, action) => {
          state.showPopUpLink = true;
        },
        closePopUpLink: (state, action) => {
          state.showPopUpLink = false;
        },
        setSelectedSubscriber: (state, action) => {
          state.selectedSubscriber = action.payload;
        },
        reportAnalytics: (state, action) => { },
    },
    extraReducers: {
        [getSurfingDataUsageDetails.fulfilled]: (state, action) => {
            return {...state, subscribers: action.payload.Body ? action.payload.Body.surfingUseDetailsItemList : [], fatalError:  action.payload.Body.error ? action.payload.Body.error : false }
        },
        [addPackage.fulfilled]: (state, action) => {
            state.isSuccessAddPackage = action.payload.Body.isSuccess;
        },
    }
})

export const { closePopUpExpanding , openPopUpExpanding, openPopUpAddPackageResult, closePopUpAddPackageResult , openPopUpLink , closePopUpLink, setSelectedSubscriber, reportAnalytics } = cellularSurfingUseDetailsBlockSlice.actions;

export default cellularSurfingUseDetailsBlockSlice.reducer;